import { observable, action } from 'mobx';
import ApiCaller from '../../utils/api-caller';

class defectReportStore {

    // Main Properties

    @observable defectReportItems = [];
    @observable defectReportPendingOrder = undefined;
    @observable defectReportRemark = '';

    // DefectReport Confirm

    @observable defectReportTimeSelected = 'now';
    @observable defectReportTimeDeliver = '';
    @observable defectReportTimeDeliverDate = '';

    // Initialization

    @action initGetDefectReports() {
        const that = this;

        const languageCode = window.localStorage.getItem('lang') || 'en';
        return ApiCaller.DefectReports.apiGetDefectReports(languageCode).then((defectReportResponses) => {
            if (defectReportResponses) {
                that.defectReportItems = defectReportResponses.items;
            } else {
                that.defectReportItems = [];
            }
        });
    }

    @action refreshDefectReports() {
        const that = this;
        that.defectReportItems = [];

        const languageCode = window.localStorage.getItem('lang') || 'en';
        return ApiCaller.DefectReports.apiGetDefectReports(languageCode).then((defectReportResponses) => {
            if (defectReportResponses) {
                that.defectReportItems = defectReportResponses.items;
            }
        });
    }

    @action initDefectReportConfirm() {
        this.defectReportRemark = '';
        this.defectReportTimeSelected = 'now';
        this.defectReportTimeDeliver = '';

        this.defectReportPendingOrder = this.defectReportItems.find(defectReportItem => defectReportItem.isSelected === true);
        return this.defectReportPendingOrder;
    }

    // GET Properties

    @action getDefectReportPendingOrder() {
        return this.defectReportItems.find(defectReportItem => defectReportItem.isSelected === true);;
    }

    // Set Properties

    @action setDefectReportIsSelected(taskId, isSelected) {
        this.defectReportItems.map(defectReportItem => {
            return defectReportItem.isSelected = false;
        });

        const defectReportItem = this.defectReportItems.find(x => x.taskId === taskId);
        defectReportItem.isSelected = isSelected;
    }

    @action setDefectReportRemark(value) {
        this.defectReportRemark = value;
    }

    @action setDefectReportTimeSelected(value) {
        this.defectReportTimeSelected = value;
        this.defectReportTimeDeliver = '';
    }

    @action setDefectReportTimeDeliver(value) {
        this.defectReportTimeDeliver = value;
        this.defectReportTimeSelected = '';
    }

    @action setDefectReportTimeDeliverDate(value) {
        this.defectReportTimeDeliverDate = value;
    }

    // RESET Properties

    @action resetDefectReports() {
        this.defectReportItems = [];
    }
}

export default new defectReportStore()